import { FC, Fragment, ReactNode } from 'react';
import { ActionGroup } from 'src/components/action-group';
import { Dropdown } from 'src/components/dropdown';
import { EmptyValue } from 'src/components/empty-value';

export type ActionItem = {
  key: string;
  component: ReactNode;
};

type TableActionsProps = {
  items: ActionItem[];
  initialActive?: boolean;
  empty?: string;
  testId?: string | number;
};

export const TableActions: FC<TableActionsProps> = ({
  items,
  initialActive = false,
  empty = 'None',
  testId,
}) => {
  const filteredItems = items.filter(({ component }) => Boolean(component));

  if (!filteredItems.length) return <EmptyValue label={empty} />;

  return (
    <ActionGroup mode="secondary" size="small">
      {filteredItems[0].component}

      {filteredItems.length > 1 ? (
        <Dropdown
          label="Show or Hide Additional Actions"
          data-testid={
            testId !== undefined ? `table-actions-toggle-${testId}` : undefined
          }
          initialActive={initialActive}
        >
          {filteredItems.slice(1).map((item) => (
            <Fragment key={item.key}>{item.component}</Fragment>
          ))}
        </Dropdown>
      ) : null}
    </ActionGroup>
  );
};
